<template>
  <div class="header--user-actions">
    <!-- <el-button type="text" v-text="'Logout'" @click="handleLogout"></el-button> -->
  </div>
</template>

<script>
export default {
  name: "app_header_logged",
  methods: {
    handleLogout() {
      this.$store.dispatch("user/logout");
      // this.$router.replace({name:'home'});
      // window.location.reload();
    }
  }
};
</script>

<style lang="stylus" scoped>
.header--user-actions
    margin-left 20px
</style>
